angular.module('impactx.printbutton').controller('PrintButtonCtrl', ['$scope', 'dataGen', 'NewWindowService', '$route',
    'ixaPrintService', PrintButton]);

function PrintButton($scope, dataGen, NewWindowService, $route, ixaPrintService) {
    $scope.newWindow = {};

    this.print = function () {
        var urlExtension = $scope.entryPointParam ? "/" + $scope.entryPointParam : '';
        if($scope.prePrintAction && typeof $scope.prePrintAction === "function") {
            var result = $scope.prePrintAction();
            if(result && typeof result.then === 'function') { // we got a promise as prePrintAction, so prevent timing problems like this
                result.then(function () {
                    printInternal($scope.printTokenFunction && typeof $scope.printTokenFunction === "function" && $scope.printTokenFunction() ? $scope.printTokenFunction() : $scope.printToken, urlExtension);
                });
            }
            else {
                printInternal($scope.printTokenFunction && typeof $scope.printTokenFunction === "function" && $scope.printTokenFunction() ? $scope.printTokenFunction() : $scope.printToken, urlExtension);
            }
        }
        else {
            printInternal($scope.printTokenFunction && typeof $scope.printTokenFunction === "function" && $scope.printTokenFunction() ? $scope.printTokenFunction() : $scope.printToken, urlExtension);
        }
    };
    
    var printInternal = function (token, urlExtension) {
        ixaPrintService.print(token, $scope.newWindow, urlExtension).then(function() {
            if ($scope.action) {
                if (typeof $scope.action === 'function') {
                    $scope.action();
                }
            }
            else {
                $route.reload();
            }
        });
    };

    this.openNewWindow = function () {
        if (!window.navigator.msSaveOrOpenBlob) {
            $scope.newWindow = NewWindowService.openNewWindow('');
        }
    };

    this.hasToken = function () {
        if (!$scope.printToken && $scope.printTokenFunction && typeof $scope.printTokenFunction === "function") {
            $scope.printToken = $scope.printTokenFunction();
        }
        return !!$scope.printToken;
    }
}
